import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React from 'react';
import { DateTimePicker } from '@mui/x-date-pickers';

export function AvlDateTimePickerField({ label = '', value, onChange, ...props }) {
    const sx = {
        '.MuiInputAdornment-root': {
            marginRight: '10px',
        },
    };

    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
        >
            <DateTimePicker
                slotProps={{
                    textField: {
                        variant: 'standard',
                        required: props.required,
                        error: props.error,
                        helperText: props.helperText,
                    },
                }}
                className={props.className}
                disabled={props.disabled}
                onChange={onChange}
                format={props.format}
                sx={props.sx || sx}
                name={props.name}
                key={props.key}
                id={props.id}
                label={label}
                value={value}
            />
        </LocalizationProvider>
    );
}
